import type { PersonColor } from '@shh/design-tokens';

/**
 * Static class maps per person colour. Tailwind only generates classes it can find literally
 * in source, so these must never be built with string interpolation.
 */
export const personSolid: Record<PersonColor, string> = {
  clay: 'bg-person-clay-solid text-person-clay-on',
  sun: 'bg-person-sun-solid text-person-sun-on',
  pine: 'bg-person-pine-solid text-person-pine-on',
  lagoon: 'bg-person-lagoon-solid text-person-lagoon-on',
  berry: 'bg-person-berry-solid text-person-berry-on',
  plum: 'bg-person-plum-solid text-person-plum-on',
  meadow: 'bg-person-meadow-solid text-person-meadow-on',
  stone: 'bg-person-stone-solid text-person-stone-on',
};

export const personSoft: Record<PersonColor, string> = {
  clay: 'bg-person-clay-soft text-text-primary',
  sun: 'bg-person-sun-soft text-text-primary',
  pine: 'bg-person-pine-soft text-text-primary',
  lagoon: 'bg-person-lagoon-soft text-text-primary',
  berry: 'bg-person-berry-soft text-text-primary',
  plum: 'bg-person-plum-soft text-text-primary',
  meadow: 'bg-person-meadow-soft text-text-primary',
  stone: 'bg-person-stone-soft text-text-primary',
};

export const personInk: Record<PersonColor, string> = {
  clay: 'text-person-clay-ink',
  sun: 'text-person-sun-ink',
  pine: 'text-person-pine-ink',
  lagoon: 'text-person-lagoon-ink',
  berry: 'text-person-berry-ink',
  plum: 'text-person-plum-ink',
  meadow: 'text-person-meadow-ink',
  stone: 'text-person-stone-ink',
};

export const personAccent: Record<PersonColor, string> = {
  clay: 'border-person-clay-solid',
  sun: 'border-person-sun-solid',
  pine: 'border-person-pine-solid',
  lagoon: 'border-person-lagoon-solid',
  berry: 'border-person-berry-solid',
  plum: 'border-person-plum-solid',
  meadow: 'border-person-meadow-solid',
  stone: 'border-person-stone-solid',
};
